import React, { Suspense } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Button, Table, Tag } from 'antd';
import { ColumnsType } from 'antd/es/table';
import Wrapper from '~/App/components/Wrapper';
import Header from '~/App/components/Header';
import { useNavigate } from 'react-router-dom';
import ErrorBoundary from '~/App/components/ErrorBoundary';
import Loading from '~/App/components/Loading';
import { UserRoleItem } from '../../types';
import api from '../../api';

const ListUserRoleTable = () => {
  const { data } = useSuspenseQuery({
    queryKey: ['fetchAllUserRole'],
    queryFn: () => {
      return api.getManyUserRole();
    },
  });
  const navigate = useNavigate();

  const columns: ColumnsType<UserRoleItem> = [
    {
      dataIndex: ['user', 'username'],
      title: 'Username',
    },
    {
      dataIndex: 'roles',
      title: 'Roles',
      render: (col: UserRoleItem['roles']) => {
        return (
          <div className="flex flex-wrap">
            {col.map(({ roleId, roleName }) => (
              <Tag key={roleId}>{roleName}</Tag>
            ))}
          </div>
        );
      },
    },
    {
      title: 'Action',
      render: (_, item) => {
        return (
          <Button
            type="primary"
            onClick={() => navigate(`edit/${item.userRestaurantRoleId}`)}
          >
            Edit
          </Button>
        );
      },
    },
  ];

  return <Table dataSource={data} columns={columns} />;
};

const ListUserRole = () => {
  const navigate = useNavigate();
  return (
    <Wrapper>
      <div className="flex justify-between">
        <Header title="User Role List" />
        <Button type="primary" onClick={() => navigate('create')}>
          + Create
        </Button>
      </div>
      <ErrorBoundary>
        <Suspense fallback={<Loading className="h-[400px]" />}>
          <ListUserRoleTable />
        </Suspense>
      </ErrorBoundary>
    </Wrapper>
  );
};

export default ListUserRole;
